import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { auditBestiary } from './perryData';

// ══════════════════════════════════════════════════════════════
//  THE BESTIARY AUDIT — dev only, once, before anything renders
// ══════════════════════════════════════════════════════════════
// The two ceilings (FOE_LYF_CEILING and ANIMA_CEILING, plus the
// common cap under it) are BUDGETS, not clamps — nothing in the
// engine stops a bad row from playing. That is on purpose: a
// silently clamped number is a wrong number that ships. So the
// only defence is being told, loudly, the moment the app boots.
//
// It runs here rather than inside a component because it is a fact
// about the DATA, not about any screen — a foe with Anima 4 is
// wrong whether or not you ever walk far enough to meet it, and
// waiting until RunDirector mounts means the road has to be played
// before the bug is heard.
//
// Stripped in production by the bundler: `process.env.NODE_ENV` is
// a compile-time constant in CRA, so the whole block folds away
// and `auditBestiary` tree-shakes out of the shipped build.
if (process.env.NODE_ENV !== 'production') {
  auditBestiary();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
